import React from "react";
import { Container, Navbar, Image, Button, Dropdown } from "react-bootstrap";
import Logo from "../../../assets/img/hvezda.png";
import Britex from "../../../assets/img/favicon.png";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import DomainSideBar from "../SideBar/domain";
import UserSideBar from "../SideBar/user";
import _authIcon from "../../../componets/json/authIcon";

class NavBar extends React.Component {
  render() {
    const { Bs, VARIANT, SIZE } = this.props;
    return (
      <Navbar className="fixed shadow-sm h-navbar">
        <Container fluid>
          <Row>
            <Col className="d-flex justify-content-start align-items-center">
              {this.props.user.type == "domain" && (
                <>
                  {this.props.screen.width < 768 && (
                    <Dropdown className="me-2">
                      <Dropdown.Toggle id="side-bar-toggle" variant="light">
                        <span className="c-placeholder c-menu c-black" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <DomainSideBar
                          {...this.props}
                          navbarClick={this.SideBarNavigate}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </>
              )}
              {this.props.user.type == "user" && (
                <>
                  {this.props.screen.width < 768 && (
                    <Dropdown className="me-2">
                      <Dropdown.Toggle id="side-bar-toggle" variant="light">
                        <span className="c-placeholder c-menu c-black" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <UserSideBar
                          {...this.props}
                          navbarClick={this.SideBarNavigate}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </>
              )}
              <Image src={Logo} className="c-logo c-squircle me-2" />
              {process.env.REACT_APP_ENV_TYPE !== "PRODUCTION" && (
                <_authIcon icon="FaDev" className="c-red fs-35 me-2" />
              )}
              <span>
                <strong className="h5">Britex</strong>
                {this.props.user?.type == "domain" && (
                  <small className="text-muted"> UI One Domain</small>
                )}
                {this.props.user?.type == "partner" && (
                  <small className="text-muted"> UI One Partner</small>
                )}
              </span>
            </Col>
          </Row>
          {this.props.screen.width > 767 && (
            <Col className="d-flex justify-content-end">
              <NavLink className={"nav-link"} to="/">
                BRITEX
              </NavLink>
              <NavLink className={"nav-link"} to="/service">
                Servis
              </NavLink>
              <NavLink className={"nav-link"} to="/repair">
                Opravy
              </NavLink>
              <NavLink className={"nav-link"} to="/info">
                Informace
              </NavLink>
              <NavLink className={"nav-link"} to="/contacts">
                Kontakty
              </NavLink>
            </Col>
          )}
          {this.props.screen.width < 768 && (
            <Col className="d-flex justify-content-end">
              <Dropdown className="me-2">
                <Dropdown.Toggle id="header-bar-toggle" variant="light">
                  <span className="c-placeholder c-menu c-black" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <NavLink className={"nav-link"} to="/">
                    BRITEX
                  </NavLink>
                  <NavLink className={"nav-link"} to="/service">
                    Servis
                  </NavLink>
                  <NavLink className={"nav-link"} to="/repair">
                    Opravy
                  </NavLink>
                  <NavLink className={"nav-link"} to="/info">
                    Informace
                  </NavLink>
                  <NavLink className={"nav-link"} to="/contacts">
                    Kontakty
                  </NavLink>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
          <Dropdown className="me-2">
            <Dropdown.Toggle id="side-bar-toggle-2" variant="light">
              <Image src={Britex} className="c-avatar" />
              {this.props.user?.userName
                ? this.props.user?.userName + " " + this.props.user?.dbName
                : "Účet"}
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-2">
              {this.props.user.type == "annonymous" && (
                <>
                  <NavLink className={"nav-link"} to="/Login">
                    Přihlásit se
                  </NavLink>
                  <NavLink className={"nav-link"} to="/Register">
                    Registrace
                  </NavLink>
                </>
              )}
              {(this.props.user.type == "user" ||
                this.props.user.type == "domain") && (
                <>
                  <Bs dropdownheader>Uživatelské menu</Bs>
                  <Bs
                    dropdownitem
                    eventKey="2"
                    onClick={() => {
                      this.props.setNavigate("/User/profile");
                    }}
                  >
                    Profil
                  </Bs>
                  <Bs
                    dropdownitem
                    eventKey="2"
                    onClick={() => {
                      this.props.setUser({ type: "annonymous" });
                      localStorage.removeItem("u");
                    }}
                  >
                    Odhlásit se
                  </Bs>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Container>
      </Navbar>
    );
  }
}

export default NavBar;
